import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-apps",
  templateUrl: "./med-icon-apps.component.html",
})
export class MedIconAppsComponent extends SvgMixinComponent {}
